import styled from '@emotion/styled';

export const WarningBox = styled.div`
  background: ${(props) => props.theme.color.blue.lightBlue};
  border: 1px solid ${(props) => props.theme.color.blue.default};
  border-radius: 10px;
  color: ${(props) => props.theme.color.blue.default};
  display: inline-block;
  font-weight: 600;
  line-height: 1.6;
  font-size: 14px;
  margin-bottom: 24px;
  margin-top: 4px;
  padding: 10px;
  text-align: center;
  text-align: left;
  width: 100%;
  white-space: break-spaces;
  a {
    color: ${(props) => props.theme.color.red.default};
    padding-bottom: 1px;

    &:hover {
      cursor: pointer;

      padding-bottom: 0px;
      border-bottom: 1px solid ${(props) => props.theme.color.red.default};
    }
  }
`;
